<template>
  <div
    class="activities"
    v-infinite-scroll="fetchMoreTimelineActivities"
    infinite-scroll-disabled="isBusy"
    infinite-scroll-distance="60"
  >
    <div class="activities__body">
      <TimelineActivity
        v-for="timelineActivity in activities"
        :key="timelineActivity.id"
        :timeline-activity="timelineActivity"
        class="activities__item"
      />
    </div>

    <div
      v-if="!isLoading && !activities.length"
      class="text-center pt-4 pb-4"
    >
      <i>Sem registro de atividades por enquanto</i>
    </div>

    <LoadingIcon
      v-if="isLoading"
    />
  </div>
</template>

<script>
  import {
    getTimelineIndex,
    getTimelineActivitiesByUser
  } from '@/api/timeline.api'
  import TimelineActivity from './TimelineActivity'
  import infiniteScroll from 'vue-infinite-scroll'
  import LoadingIcon from '@/components/layout/LoadingIcon'

  export default {
    components: {
      LoadingIcon,
      TimelineActivity,
    },

    props: {
      userId: { type: Number, default: null }
    },

    directives: {
      infiniteScroll,
    },

    data: () => ({
      isDone: false,
      page: 1,
      isLoading: false,
      activities: []
    }),

    destroyed () {
      this.activities = []
      this.page = 1
    },

    computed: {
      isBusy () {
        return this.isLoading || this.isDone
      }
    },

    methods: {
      async fetchMoreTimelineActivities () {
        this.isLoading = true

          const response = this.userId
            ? await getTimelineActivitiesByUser(this.userId, { page: 1})
            : await getTimelineIndex({ page: this.page++ })

        response.data.data.forEach(i => this.activities.push(i))

        if (!response.data.next_page_url) {
          this.isDone = true
        }

        this.isLoading = false
      }
    }
  }
</script>

<style scoped lang="scss">
  .activities {
    position: relative;

    &__body {
      position: relative;

      &:before {
        content: '';
        position: absolute;
        left: 42px;
        top: 4px;
        transform: translateX(-16px);
        border-left: 2px dashed lighten(#000, 85%);
        height: 100%;
      }
    }

    &__item {
      &:not(:last-child):after {
        content: '';
        width: 30px;
        height: 3px;
        // background-color: #ff8800;
        margin: 12px auto;
        // transform: translateX(25px);
      }
    }
  }
</style>